import { Button, CardContent, CardHeader, IconButton } from "@material-ui/core";
import { ArrowForward, ArrowForwardIos } from "@material-ui/icons";
import React from "react";
import { useContacts } from "../../../contexts";
import { Container } from "./styles";

export default function Item({
  leftAction,
  RightIcon,
  rightTitle,
  spotlight,
  title,
  children,
  ...props
}) {
  const { setSpotlight } = useContacts();

  function action() {
    return (
      spotlight &&
      (RightIcon ? (
        <Button
          onClick={() => setSpotlight(spotlight)}
          startIcon={<RightIcon />}
        >
          {rightTitle}
        </Button>
      ) : (
        <IconButton
          aria-label="settings"
          onClick={() => setSpotlight(spotlight)}
        >
          <ArrowForwardIos />
        </IconButton>
      ))
    );
  }

  return (
    <Container variant="outlined">
      <CardHeader avatar={leftAction} action={action()} title={title} />
      <CardContent>{children}</CardContent>
    </Container>
  );
}
